export { Accordion, type AccordionProps } from "./Accordion.component";
